export const APP_URL = window.location.href.split('?')[0].replace(/(\/)*$/, "/");
export const APP_PATH = (() => {
	var el = document.createElement('a');
		el.href = APP_URL;
	return el.pathname;
})()